module.exports = __webpack_public_path__ + "img/sy-pic4.440d732c.png";